// src/utils/sound.ts
export const playSuccessSound = () => {
  const audio = new Audio('/success.mp3');
  audio.play().catch(error => console.error("Failed to play success sound:", error));
};

export const playErrorSound = () => {
  const audio = new Audio('/error.mp3');
  audio.play().catch(error => console.error("Failed to play error sound:", error));
};

export const playWarningSound = () => {
  const audio = new Audio('/warning.mp3');
  audio.play().catch(error => console.error("Failed to play warning sound:", error));
}; 